/**
 * IE 10 polyfills
 * @todo To avoid global scope polution by switching to babel-runtime-transform
 * we need to fix or replace unreliable vue-match-media plugin.
 */
import 'core-js/es6/promise'
import 'core-js/es6/array'
import 'core-js/es6/set'
import 'core-js/fn/promise/finally'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MQ from 'vue-match-media/dist' // @see https://github.com/drenglish/vue-match-media/issues/2
import EventHub from '@/plugins/EventHub'
import VueTranslate from 'vue-translate-plugin'

// import eventHub from '@services/EventHub'
// import heartBeat from '@services/HeartBeat'
import apiClient from '@services/ApiClient'
import localeManager from '@services/LocaleManager'

import ToolbarApi from '@/api/ToolbarApi'
import ToolbarData from '@models/ToolbarData/model'

import * as ToolbarEvents from '@events/Toolbar'

import VectorComponent from '@components/Vector'
import ToolbarComponent from '@components/Toolbar'

// import NotificationSensor from '@services/HeartBeat/Sensors/NotificationSensor'

if (!global._babelPolyfill) {
  require('babel-polyfill')
}

Vue.use(MQ)
Vue.use(EventHub)
Vue.use(VueTranslate)

Vue.component('vector', VectorComponent)

Vue.config.productionTip = false

function Toolbar (options) {
  // Default settings
  const settings = Object.assign({
    apiUrl: process.env.API_URL,
    accountUrl: process.env.ACCOUNT_URL,
    profileId: null,
    loginState: null,
    loginRedirectUrl: null,
    burgerMenu: true,
    hasLoginPermissionForAccount: false,
    sessionTimeout: process.env.SESSION_TIMEOUT,
    breakpoints: {
      phone: process.env.LAYOUT_BP_PHONE,
      desktop: process.env.LAYOUT_BP_DESKTOP
    },
    userEmail: null
  }, options)

  // Pre-configure API client
  apiClient.setOptions({
    baseUrl: settings.apiUrl
  })

  // Register heartbeat sensors
  // heartBeat.addSensor(new NotificationSensor()) // @todo To be implemented...

  const toolbar = new Vue({
    mq: {
      'phone': settings.breakpoints.phone,
      'desktop': settings.breakpoints.desktop
    },
    components: {
      toolbar: ToolbarComponent
    },
    data () {
      return {
        // Use undefined for default values to take place
        toolbarData: undefined
      }
    },
    computed: {
      settings () {
        return settings
      }
    },
    created () {
      this.setLocale(localeManager.getLocale().toString())
      this.loadData()
    },
    methods: {
      loadData () {
        return new ToolbarData().fetch()
          .then(toolbarData => {
            // @todo Implement state manager, too much props to pass :(
            this.$set(this, 'toolbarData', toolbarData)
          })
          .catch(e => {
            this.$sendSystemEvent(Toolbar.EVENT_ERROR, e)
          })
      },
      setLocale (locale) {
        this.$translate.setLang(locale)
      }
    },
    template: `
      <toolbar
        :settings="settings"
        :toolbar-data="toolbarData"
      />`
  })

  return new ToolbarApi(toolbar)
}

// Public toolbar events
Toolbar.EVENT_ERROR = ToolbarEvents.EVENT_ERROR
Toolbar.EVENT_PROFILE_CHANGE = ToolbarEvents.EVENT_PROFILE_ITEM_CLICK
Toolbar.EVENT_LANGUAGE_CHANGE = ToolbarEvents.EVENT_LANGUAGE_ITEM_CLICK
Toolbar.EVENT_BURGER_MENU_CLICK = ToolbarEvents.EVENT_BURGER_MENU_CLICK

window.Bilderlings = {
  ui: {
    Toolbar
  }
}

/**
 * For async includes
 * @todo Implement native events
 */
if (typeof document.onbilderlingstoolbarready === 'function') {
  document.onbilderlingstoolbarready(Toolbar)
}



// WEBPACK FOOTER //
// ./src/main.js